import React from 'react';

interface HeadingElementProps {
  text: string;
}

export const HeadingElement: React.FC<HeadingElementProps> = ({ text }) => {
  return <h3 className="m-0 text-[19px] font-bold leading-8 text-ds-ink">{text}</h3>;
};
